import Resource from './Resource'

export interface IWorkingDayType {
  id: number
  legal_entity_id: number
  name: string
  default: true
  archived: false
}
class WorkingDayType extends Resource {
  static urlRoot() {
    return '/contracts/spain/working_day_types'
  }
}

export default WorkingDayType
